import { render, staticRenderFns } from "./ReasonForCancellation.vue?vue&type=template&id=dd532434&lang=pug&"
import script from "./ReasonForCancellation.vue?vue&type=script&lang=js&"
export * from "./ReasonForCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports